<!---Global-loader-->

<div *ngIf="isSpinnerVisible">
    <div id="global-loader">
        <img src="./assets/images/svgs/loader.svg" class="loader-img" alt="loader">
    </div>
</div>
<!--- End Global-loader-->
